import { createSelector } from 'reselect';
import _ from 'lodash';

import { ADMIN, INSTRUCTOR, INSTRUCTOR_VIEW_ONLY, STUDENT } from "../constants/roles";

const rolesSelector = state => state.roles;

const getHighestDropboxRole = (roles) => {
    return _.pick(
        _.last(
            _.sortBy(
                roles,
                [
                    role => {
                        return role.role === ADMIN;
                    },
                    role => {
                        return role.role === INSTRUCTOR;
                    },
                    role => {
                        return role.role === INSTRUCTOR_VIEW_ONLY;
                    },
                    role => {
                        return role.role === STUDENT;
                    }
                ]
            )
        ),
        ['role']
    ).role;
};

export default createSelector(
    rolesSelector,
    getHighestDropboxRole
);


/** WEBPACK FOOTER **
 ** ./src/selectors/HighestDropboxRoleSelector.js
 **/